// Registro local de cuántas veces se ha agregado cada producto desde este dispositivo.
// Sirve para mostrar los productos "Frecuentes" sin depender del backend.

const STORAGE_KEY = 'pos_product_frequency';

type FrequencyMap = Record<string, number>;

function load(): FrequencyMap {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as FrequencyMap) : {};
  } catch {
    return {};
  }
}

function save(map: FrequencyMap) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch {
    // ignore
  }
}

/** Suma 1 al contador del producto cuando el mesero lo agrega al pedido. */
export function trackProductUse(productId: string | number) {
  const id = String(productId);
  const map = load();
  map[id] = (map[id] ?? 0) + 1;
  save(map);
}

/** Devuelve los IDs ordenados de más usado a menos usado. */
export function getFrequentProductIds(): string[] {
  const map = load();
  return Object.entries(map)
    .sort((a, b) => b[1] - a[1])
    .map(([id]) => id);
}

/** Mapa crudo de frecuencias (para ordenar listas). */
export function getFrequencyMap(): FrequencyMap {
  return load();
}
